import { ChecklistIcon, EmptyChecklistIcon, MixedChecklistIcon, WaitlistIcon } from "@xola/icons";
import { ButtonGroup, Tooltip } from "@xola/ui-kit";
import React from "react";
import { useDashboardFilterStore } from "../../../stores/dashboardFilterStore";
import { DashboardMode, DashboardScope } from "../../../types/Dashboard";

const items = [
    {
        name: "Reserved",
        key: DashboardScope.RESERVED,
        icon: ChecklistIcon,
    },
    {
        name: "Waitlist",
        key: DashboardScope.WAITLIST,
        icon: WaitlistIcon,
    },
    {
        name: "Available",
        key: DashboardScope.AVAILABLE,
        icon: EmptyChecklistIcon,
    },
    {
        name: "All",
        key: DashboardScope.ALL,
        icon: MixedChecklistIcon,
    },

    // For equipment dashboard
    {
        name: "Assigned",
        key: DashboardScope.ASSIGNED,
        icon: EmptyChecklistIcon,
    },
];

export const AvailabilityScopeButtons = () => {
    const scope = useDashboardFilterStore((state) => state.filters.scope);
    const setFilters = useDashboardFilterStore((state) => state.setFilters);
    const filters = useDashboardFilterStore((state) => state.filters);

    const relevantItems = items.filter((item) =>
        filters.mode === DashboardMode.EQUIPMENT
            ? item.key === DashboardScope.ALL || item.key === DashboardScope.ASSIGNED
            : item.key !== DashboardScope.ASSIGNED,
    );
    const activeIndex = relevantItems.findIndex((item) => item.key === scope);

    const handleChange = (index: number) => {
        setFilters({
            scope: relevantItems[index].key,
            products: filters.products,
            guide: filters.guide,
            resource: {
                showUnassigned:
                    relevantItems[index].key === DashboardScope.ASSIGNED ? false : filters.resource.showUnassigned,
                all: filters.resource.all,
                selected: filters.resource.selected,
            },
        });
    };

    return (
        <ButtonGroup isCollapsed className="align-top" size="small" value={activeIndex} onChange={handleChange}>
            {relevantItems.map((type, index) => {
                const Icon = type.icon;
                return (
                    <ButtonGroup.Button
                        key={type.key}
                        className="h-7.5 px-2.5 text-base"
                        data-testid={`dashboard-availability-button-${type.key}`}
                        disabled={filters.mode === DashboardMode.TABLE && type.key !== DashboardScope.RESERVED}
                    >
                        <Tooltip offset={[0, 18]} content={type.name} disabled={activeIndex === index}>
                            <div className="w-full space-x-1">
                                <Icon size="medium" /> {activeIndex === index && type.name}
                            </div>
                        </Tooltip>
                    </ButtonGroup.Button>
                );
            })}
        </ButtonGroup>
    );
};
